import { PATH_THANKYOU, PATH_CHECKOUT } from "../../constants/Paths";
import { proceedOrderToServer } from "../../logic/server/OrderFunction";
import { buildOrderPayloadV2 } from "../../logic/server/PayloadBuilder";
import { replaceCart } from "../kit/Redux/Actions";

// 28/Jun/2024 VE - New Function
//

export const submitNewOrder = async (utils, user, order, cartItems, selectedStore = null) => {
  const { webApp, sessionToken, navigate, dispatch } = utils;
  try {
    const {
      userId,
      userName,
      agentId,
      routeDetails,
      customerName,
      customerContact,
      customerAddress,
      timeSlot,
      customerComments,
    } = user;

    const {
      isDeliveryWaived,
      discountAmount,
      deliveryCost,
      surchargeCost,
      paymentCost,
      storeTotalCost,
      charges,
    } = order;

    const userDetails = {
      userId: userId,
      userName: userName,
    };

    const postalCodeDetails = {
      address: customerAddress,
      postalCodeDescr: routeDetails.postalcodedescr,
    };

    const featureFlags = {
      isDeliveryWaived,
    };

    const orderCosts = {
      discountAmount: discountAmount,
      deliveryCost: deliveryCost,
      surchargeCost: surchargeCost,
      baseCost: paymentCost,
      storeTotalCost: storeTotalCost,
      charges: charges,
    };

    const customerDetails = {
      orderName: customerName,
      orderPhone: customerContact,
      orderAddress: customerAddress,
      orderComments: customerComments,
    };

    const orderSummary = buildOrderPayloadV2(
      userDetails,
      customerDetails,
      postalCodeDetails,
      featureFlags,
      cartItems,
      timeSlot,
      orderCosts,
      routeDetails,
      agentId
    );

    const result = await proceedOrderToServer(sessionToken, orderSummary, selectedStore);

    // Handle different result scenarios
    if (result && result.success && result.order) {
      // Navigate to success page
      navigate(PATH_THANKYOU, {
        replace: true,
      });

    } else if (result && result.data?.error === "INVENTORY_CONFLICT") {
      // Handle inventory conflict — items went out of stock during checkout
      webApp.MainButton.hideProgress(true);
      webApp.BackButton.show();

      const unavailableItems = result.data.unavailableItems || [];
      const unavailableMap = new Map(unavailableItems.map(i => [i.productId, i]));

      // Build updated cart: adjust quantities for partial stock, remove fully out-of-stock
      const updatedCart = cartItems
        .map(item => {
          const conflict = unavailableMap.get(item.id);
          if (!conflict) return item; // no conflict, keep as-is
          if (conflict.available <= 0) return null; // fully out of stock, remove
          return { ...item, quantity: conflict.available, availableQty: conflict.available }; // adjust to what's available
        })
        .filter(Boolean);

      // Build detailed item descriptions
      const itemDescriptions = unavailableItems.map(item => {
        const parts = [item.type, item.brand, item.category, item.title].filter(Boolean);
        const desc = parts.join(" - ");
        return item.available > 0
          ? `${desc} (reduced from ${item.requested} to ${item.available})`
          : `${desc} (out of stock - removed)`;
      });

      // Update cart with adjusted quantities
      if (dispatch) {
        dispatch(replaceCart(updatedCart));

        // Update product list availableQty so Product Screen shows correct stock
        dispatch({
          type: "UPDATE_PRODUCT_AVAILABILITY",
          payload: unavailableItems.map(item => ({
            id: item.productId,
            availableQty: item.available,
          })),
        });
      }

      alert(
        `Some items are no longer available.\n\n` +
        itemDescriptions.join("\n") +
        `\n\nYour cart has been updated. Redirecting to cart...`
      );

      navigate(PATH_CHECKOUT, { replace: true });
      console.error("Inventory conflict during order creation:", result.data);

    } else {
      // Handle other failed order creation
      webApp.MainButton.hideProgress(true);
      webApp.BackButton.show();

      const errorMessage = result?.error || "Order creation failed. Please try again.";
      const isRetryable = result?.isRetryable !== false;

      let alertMessage = `Order Failed: ${errorMessage}`;
      if (isRetryable) {
        alertMessage += "\n\nPlease try again by clicking the Pay button.";
      } else {
        alertMessage += "\n\nPlease check your order details and try again.";
      }

      alert(alertMessage);
      console.error("Order submission failed:", result);
    }
  } catch (error) {
    console.error("Unexpected error during order submission:", error);
    webApp.MainButton.hideProgress(true);
    webApp.BackButton.show();
    
    // Handle unexpected errors gracefully
    let errorMessage = "An unexpected error occurred while processing your order.";
    
    if (error.message && error.message.includes('network')) {
      errorMessage = "Network error occurred. Please check your connection and try again.";
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    alert(`Order Error: ${errorMessage}\n\nPlease try again by clicking the Pay button.`);
    
    // Don't navigate away - let user retry
  }
};
